<template>
    <div >
        <div class="row no-gutters">
            <div class="col-12 text-center">
                <h2 class=" mt-5 mb-3">Great, you're almost there!</h2>
                <p class="text-success text-center h5" v-if="recommendationSavings">Your estimated annual savings are &pound;{{recommendationSavings}} !</p>
                <p class="font-weight-bold h5"  v-if="$store.getters['auth/hasWorthlessDeal']">
                    We'll now get to work finding the most competitively priced supplier and will notify you as soon we have the details.
                </p>
                <button class="btn btn-success btn-success-gradient pl-4 my-3" @click="previewDetails = !previewDetails">
                    <i class="fa fa-eye mr-4"></i>
                    <span v-if="!previewDetails">Preview switching details</span>
                    <span v-else>Minimize switching details</span>
                </button>
                <collapse-transition>
                <survey-details v-if="previewDetails" />
                </collapse-transition>
                <p class="py-3 px-2 px-lg-5 font-grow-2pt">Now, we just need your billing information for your new energy supplier, so they can set up a Direct Debit, once the switch has been completed. This also allows us to switch you again for FREE, when we find a better deal for you in the future.</p>
                <hr class="mx-5">
                <p class=" h5 font-weight-normal my-4">... and please <span class="font-weight-bold text-uppercase">don’t worry!</span></p>
                <p class="tick">MySwitchPro is 100% FREE and we'll NEVER take money from your account!</p>
                <p class="tick">No charges, No penalties! … We make sure you don’t incur exit fees!</p>
                <p class="tick">Your information is secure and safe with us!</p>
                <p class="tick">We always keep you updated and you can always check your current supplier status via your web dashboard.</p>
                <p class="tick">If you change your mind, you have 14 days to cancel, even if your switch has already started.</p>

            </div>
        </div>
        <div class="row mt-5">
            <div class="col-12">
                <div class="card shadow-sm">
                    <div class="card-body p-4 p-lg-5">
                        <direct-debit-form ref="directDebitForm" />
                    </div>
                </div>
            </div>
        </div>
        <div class="row mt-5">
            <div class="col-12 text-center font-grow-2pt">
                Do you have any follow-up questions or just need reassurance?<br />
                Check out our <router-link to="/help" target="_blank">FAQs</router-link> or contact our support team at
                <a href="mailto:helpdesk@myswitchpro.com">helpdesk@myswitchpro.com</a>
            </div>
            <div class="col-12 col-lg-4 mx-auto mt-4 mb-5">
                <button class="btn btn-success btn-success-gradient btn-lg btn-block" @click="submit" :disabled="running"
                        v-if="$store.getters['auth/hasWorthlessDeal']">
                    Confirm
                </button>
                <button class="btn btn-success btn-success-gradient btn-lg btn-block" @click="submit" :disabled="running"
                        v-else>
                    Switch me
                </button>
                <div class="text-danger" v-if="errors.details">
                    Problem with saving your payment details!
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import DirectDebitForm from "../../components/setup/DirectDebitForm";
import SurveyDetails from "@/components/setup/SurveyDetails";
import {CollapseTransition} from 'vue2-transitions'
import api from "@/utils/api";

export default {
        name: "Debit",
        components: {SurveyDetails, DirectDebitForm, CollapseTransition},
        data() {
            return {
                previewDetails: this.$route.params.details || false,
                running: false,
                recommendationSavings: null,
                errors: {
                    details: null
                }
            }
        },
        methods: {
            submit() {
                let that = this;
                that.errors  = {
                    details: null
                }
                this.$refs.directDebitForm.$v.$touch()
                if(this.$refs.directDebitForm.$v.$invalid){
                    return
                }
                that.running = true;
                this.$refs.directDebitForm.clearErrors();
                
                api.savePaymentDetails(this.$refs.directDebitForm.getFormData()).then( () =>{
                    api.profile().then(response => {
                        that.$store.commit('auth/setUser', response.data.data);
                    }).finally(() => {
                        that.$router.push({name: 'SetupComplete'})
                        that.running = false;
                    })
                }).catch( (e) => {
                    that.running = false;
                    if(e.response.status === 400 && e.response.data.error.code === 11111){
                        this.$refs.directDebitForm.setErrors(e.response.data.meta);
                    }  else  {
                        that.errors.details = true;
                    }
                })
                
            }
        },
        mounted() {
            let that = this;
            api.property('latest').then(result => {
                that.recommendationSavings = result.data.data.recommendation ? result.data.data.recommendation.savings : null
            })
        }
    }
</script>

<style scoped lang="scss">
    @import "../../sass/base";
    .tick {
        font-size: 1.2rem;
        vertical-align: middle;
        font-weight: bold;

        &:before {
            content: url("../../assets/images/check 1.svg");
            vertical-align: middle;
            display: inline-block;
            width: 26px;
            height: 26px;
            margin-right: 1rem;
        }
    }
a .card {
        @include media-breakpoint-down(lg){
            border: none;
            box-shadow: none !important;
        }
    }
    .font-grow-2pt{
        font-size: $font-size-base*1.125;
    }
</style>
